(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rl-cart-extra"] && !Shopify.designMode) return;
  try {
    /* Weekly offer countdown in the cart (tier box + top strip). Global script, so it also runs after the drawer is
     re-rendered by an add to cart (the old inline <script> did not, and the clock showed no time; 2026-10-21 fix). */
  (function () {
    if (window.__rlTierCd) return; window.__rlTierCd = 1;
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      document.querySelectorAll('.rl-cx-tier[data-rl-end], .rl-cx-strip[data-rl-end]').forEach(function (el) {
        var left = +el.getAttribute('data-rl-end') - Date.now(), cd = el.querySelector('[data-rl-cd]');
        if (left <= 0) { el.remove(); return; }
        var d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
        if (cd) cd.textContent = 'Termina en ' + (d ? d + 'd ' : '') + p(h) + ':' + p(m) + ':' + p(s);
      });
    };
    tick(); setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
